var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import { Button, ExpandablePanel, Link } from "@atlassiansox/microscopekit";
import DynamicTable from "@atlaskit/dynamic-table";
import { parseDateTime, statusLozenge } from "../../utils";
import { SortOrder } from "../../graphql";
import Pagination from "@atlaskit/pagination";
import { CentreAlignDiv, FilterContainer } from "../../utils/styles";
import { MultiSelect } from "../MultiSelect";
import Form from "@atlaskit/form";
import { CronosFilterOptions } from "../../utils/cronos";
var getHead = function () {
    var head = {
        cells: [
            {
                key: "id",
                content: "ID.",
                isSortable: true
            },
            {
                key: "wargame-plan",
                content: "Wargame Template",
                isSortable: true
            },
            {
                key: "wargame-environment",
                content: "Environment"
            },
            {
                key: "status",
                content: "Status",
                isSortable: true
            },
            {
                key: "updated-at",
                content: "Updated At (mm/dd/yyyy)",
                isSortable: true
            }
        ]
    };
    return head;
};
export var CronosRecentWargamesListView = function (props) {
    var _a, _b;
    var _c = __read(useState(true), 2), isCollapsed = _c[0], setIsCollapsed = _c[1];
    var _d = __read(useState({}), 2), appliedFilter = _d[0], setAppliedFilter = _d[1];
    var _e = __read(useState(0), 2), pageNumber = _e[0], setPageNumber = _e[1];
    var fields = {
        environment: "Environment",
        wargameTemplateName: "Wargame Template",
        status: "Status"
    };
    var applyFilter = useCallback(function (e) {
        setAppliedFilter(e);
    }, []);
    var navigateTo = function (pageNumber) {
        setPageNumber(pageNumber);
    };
    useEffect(function () {
        var _a;
        (_a = props.getData) === null || _a === void 0 ? void 0 : _a.call(props, {
            variables: {
                filter: {
                    service: {
                        eq: props.serviceId
                    },
                    trigger: {
                        in: [props.trigger]
                    },
                    environment: {
                        in: appliedFilter.environment
                    },
                    status: {
                        in: appliedFilter.status
                    },
                    wargame_template_name: {
                        in: appliedFilter.wargameTemplateName
                    }
                },
                limit: 10,
                page: pageNumber,
                sortColumn: "id",
                sortOrder: SortOrder.DESC
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appliedFilter, pageNumber]);
    return (React.createElement("div", null,
        React.createElement("br", null),
        React.createElement(FilterContainer, null,
            React.createElement(ExpandablePanel, { isCollapsed: isCollapsed, title: "Filters", onToggle: function () { return setIsCollapsed(function (prevState) { return !prevState; }); } },
                React.createElement(Form, { onSubmit: function (e) { return applyFilter(e); } }, function (_a) {
                    var formProps = _a.formProps;
                    return (React.createElement("form", __assign({}, formProps),
                        Object.entries(fields).map(function (_a) {
                            var _b;
                            var _c = __read(_a, 2), field = _c[0], label = _c[1];
                            return (React.createElement(MultiSelect, { key: field, name: field, label: label, placeholder: "Select " + label, options: (_b = CronosFilterOptions === null || CronosFilterOptions === void 0 ? void 0 : CronosFilterOptions[field]) !== null && _b !== void 0 ? _b : [] }));
                        }),
                        React.createElement("br", null),
                        React.createElement(Button, { type: "submit", appearance: "primary" }, "Apply")));
                }))),
        React.createElement(DynamicTable, { isLoading: props.isLoading, caption: "Recent Wargames", head: getHead(), isFixedSize: true, rows: (_a = props === null || props === void 0 ? void 0 : props.serviceWargamesData) === null || _a === void 0 ? void 0 : _a.map(function (wargame) {
                var updatedAt = wargame.updatedAt
                    ? parseDateTime(wargame.updatedAt)
                    : "";
                return {
                    key: "row-" + wargame.id,
                    cells: [
                        {
                            key: "wargame-" + wargame.id,
                            content: (React.createElement(Link, { to: "/services/" + encodeURIComponent(props.serviceId) + "/resilience/ondemand/wargame-details?id=" + wargame.id }, wargame.id))
                        },
                        {
                            key: "wargame-name-" + wargame.wargameTemplateName,
                            content: wargame.wargameTemplateName
                        },
                        {
                            key: "wargame-environment-" + wargame.environment,
                            content: wargame.environment
                        },
                        {
                            key: "wargame-status-" + wargame.status,
                            content: statusLozenge(wargame.status)
                        },
                        {
                            key: "wargame-updated-" + updatedAt,
                            content: updatedAt
                        }
                    ]
                };
            }), emptyView: React.createElement("div", null, "No Records Found"), rowsPerPage: 10 }),
        React.createElement(CentreAlignDiv, null,
            React.createElement(Pagination, { selectedIndex: pageNumber, nextLabel: "Next", label: "Page", pageLabel: "Page", pages: Array.from({ length: (_b = props.pageCount) !== null && _b !== void 0 ? _b : 0 }, function (_, index) { return index + 1; }), onChange: function (_, page) { return navigateTo(page - 1); }, previousLabel: "Previous" }))));
};
